import {Link} from "react-router-dom";
import MobileSidebar from "./mobile-sidebar";
import React, {useState} from "react";

const MobileMenu = ({ homePage = true }) => {

  const [showSidebar, setShowSidebar] = useState(false);

  const handleToggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  return (
      <header className="main-header main-header-mobile">
            <div className="auto-container">
              <div className="inner-box">
                <div className="nav-outer">
                  <div className="logo-box">
                    <div className="logo">
                      {homePage ? (
                          <a href={'/#'}>
                            <img src="/images/Logo-GTH-24.png"
                                 alt="Groupe Talents Handicap"
                                 className="logo"
                                 width={265}
                                 height={50}
                            />
                          </a>
                      ) : (
                          <img src="/images/Logo-GTH-24.png"
                               alt="Groupe Talents handicap"
                               className="logo"
                               width={265}
                               height={50}
                          />
                      )}
                    </div>
                  </div>
                  {homePage && (
                      <MobileSidebar show={showSidebar} onClose={handleToggleSidebar} />
                  )}
                </div>

                {homePage ? (
                  <div className="outer-box">
                    <button
                        className="mobile-nav-toggler"
                        onClick={handleToggleSidebar}>
                      <img src="/images/icons/icon-menu.png" alt='ico menu'/>
                    </button>
                  </div>
                ) : (
                  <Link to={'/'}>Retour à l'accueil</Link>
                )}
              </div>
            </div>
          </header>
  );
};

export default MobileMenu;
